import debounce from './debounce.js';

/**
 * Handle scroll to right of element
 * @param {Object} element element
 * @param {*} callback callback function execute after scroll to right
 */
function scrollToRight(element, callback) {
	const checkScrollToRight = debounce(async (e) => {
		const scrollToRightWidth = e?.target?.scrollWidth - e?.target?.offsetWidth;
		const isScrollToRight = e?.target?.scrollLeft >= scrollToRightWidth;

		if (isScrollToRight) {
			await callback();
		}
	});

	element.addEventListener('scroll', checkScrollToRight);
}

/**
 * Handle scroll to bottom of element
 * @param {Object} element element
 * @param {*} callback callback function execute after scroll to bottom
 */
function scrollToBottom(element, callback) {
	const checkScrollToBottom = debounce(async (e) => {
    const scrollToBottomHeight = e?.target?.scrollHeight - e?.target?.offsetHeight;
		const isScrollToBottom = e?.target?.scrollTop >= scrollToBottomHeight

		if (isScrollToBottom) {
			await callback();
		}
	});

	element.addEventListener('scroll', checkScrollToBottom);
}

export { scrollToRight, scrollToBottom };
